import { render, staticRenderFns } from "./c-wizard-dialog.vue?vue&type=template&id=32c023ca&scoped=true&"
import script from "./c-wizard-dialog.vue?vue&type=script&lang=js&"
export * from "./c-wizard-dialog.vue?vue&type=script&lang=js&"
import style0 from "./c-wizard-dialog.vue?vue&type=style&index=0&id=32c023ca&lang=scss&scoped=true&"
import style1 from "./c-wizard-dialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c023ca",
  null
  
)

export default component.exports